"use client";

import { motion } from "framer-motion";
import { Star, ArrowRight, MessageCircle } from "lucide-react";
import { GlassCard } from "./glass-card";
import { GradientBorder } from "./gradient-border";

export function TrustpilotSection() {
  return (
    <section className="relative px-4 py-20 md:py-28">
      <div className="mx-auto max-w-5xl">
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          <h2 className="text-3xl font-bold tracking-tight text-white sm:text-4xl">
            Du client satisfait à l&apos;avis public
          </h2>
          <p className="mx-auto mt-4 max-w-2xl text-slate-400">
            Après chaque ticket clôturé, envoyez un court sondage CSAT. Les clients les plus
            satisfaits sont invités à partager leur avis sur Trustpilot — sans friction.
          </p>
        </motion.div>

        <motion.div
          className="mt-12 grid gap-6 sm:grid-cols-3"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: {},
            visible: { transition: { staggerChildren: 0.12 } },
          }}
        >
          <motion.div variants={{ hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0 } }}>
            <GlassCard className="h-full text-center">
              <div className="flex justify-center">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-emerald-500/20 text-emerald-400">
                  <MessageCircle className="h-6 w-6" />
                </span>
              </div>
              <h3 className="mt-4 font-semibold text-white">Ticket clôturé</h3>
              <p className="mt-2 text-sm text-slate-400">
                Envoi automatique du lien de satisfaction (email, WhatsApp ou chat).
              </p>
            </GlassCard>
          </motion.div>

          <motion.div variants={{ hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0 } }}>
            <GradientBorder className="h-full" glow>
              <div className="flex h-full flex-col items-center justify-center p-6 text-center">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-cyan-500/20 text-cyan-400">
                  <Star className="h-6 w-6" />
                </span>
                <h3 className="mt-4 font-semibold text-white">Score ≥ 4/5</h3>
                <p className="mt-2 text-sm text-slate-400">
                  Proposition d&apos;aller déposer un avis sur votre page Trustpilot.
                </p>
              </div>
            </GradientBorder>
          </motion.div>

          <motion.div variants={{ hidden: { opacity: 0, y: 16 }, visible: { opacity: 1, y: 0 } }}>
            <GlassCard className="h-full text-center">
              <div className="flex justify-center">
                <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-amber-500/20 text-amber-400">
                  <ArrowRight className="h-6 w-6" />
                </span>
              </div>
              <h3 className="mt-4 font-semibold text-white">Avis publics</h3>
              <p className="mt-2 text-sm text-slate-400">
                Plus d&apos;avis vérifiés, meilleure crédibilité et SEO pour votre marque.
              </p>
            </GlassCard>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
